import { useState, useCallback } from "react"
import { api } from "../utils/apiComponent/apiClient"
import { endpoints } from "../utils/endpoints"
import { showSuccessToast, showErrorToast } from "../utils/toast"

/**
 * Hook to complete a lesson (marks all blocks as completed)
 * POST /course-progress/lessons/:lessonId/complete
 * @returns {Object} - { complete, loading, error }
 */
export function useCompleteLesson() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const complete = useCallback(async (lessonId) => {
    setLoading(true)
    setError(null)
    
    try {
      // api.post retourne directement data si success: true, ou lance une erreur si success: false
      const response = await api.post(endpoints.completeLesson(lessonId), {})
      
      // Si on arrive ici, c'est que l'API a réussi (api.post gère déjà les erreurs)
      // Le toast de succès est géré dans completeCurrentLesson pour éviter les doublons
      return response
    } catch (err) {
      const errorMessage = err?.response?.data?.message || err?.message || "Erreur lors de la validation du chapitre"
      setError(errorMessage)
      showErrorToast({ message: errorMessage })
      throw err
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    complete,
    loading,
    error
  }
}

